import { useSelector } from "react-redux";
import { AppState } from "../store/store";

export const useNotification = () => {
    return useSelector((state: AppState) => state.notification.notifications);
};
